export const SUPPORTS_SYMBOL = typeof Symbol !== "undefined";
